module.exports = __webpack_public_path__ + "img/Bodice-Front-B3-Gd-Da-Ef.c4dec122.png";